import React from 'react';
import { BRAND_LOGOS } from '../landing-page/data/brands';

// Brand roster marquee along a hero's bottom edge — the hero floor on the
// main tab heroes (dark video walls) and on the solution subpages (posters).
// The logo assets carry a white-to-grey gradient baked into the pixels;
// brightness(0) flattens them to a solid black silhouette, invert(1) then
// turns that white for dark or magenta heroes. No divider lines between or
// above the logos.
// No loading="lazy": inside a continuously transformed loop the browser's
// lazy-load heuristic misfires (worst on mobile Safari) and logos drop out.
const HeroBrandMarquee = ({ bg, invert = true }) => (
  // 45s per loop: a touch calmer than the 32s default of the text marquees.
  <div className="flex will-change-transform animate-infinite-scroll-fast" style={{ animationDuration: '45s' }}>
    {[0, 1].map((set) => (
      <div key={set} className="flex items-center flex-shrink-0" aria-hidden={set === 1 ? true : undefined}>
        {BRAND_LOGOS.map((logo, i) => (
          <div key={i} className="flex items-center gap-4 px-4 md:px-10 py-2 md:py-3 flex-shrink-0" style={{ backgroundColor: bg }}>
            <img
              src={logo.src}
              alt={logo.alt}
              width={200}
              height={80}
              className="max-h-12 md:max-h-16 w-auto object-contain opacity-95"
              style={{ filter: invert ? 'brightness(0) invert(1)' : 'brightness(0)' }}
            />
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default HeroBrandMarquee;
